// Dizionari delle funzioni del manuale: banco, sprechi, peso, extra, cassa, impasto, backup.
export const MAN_D = {
  it: {
    "nav.cassa": "Cassa e incassi", "nav.sprechi": "Sprechi e annulli", "nav.backup": "Backup e ripristino",
    "nav.attesa": "Lista d'attesa", "nav.piatti-giorno": "Piatti del giorno", "nav.guida": "Guida rapida", "nav.manuale": "Manuale d'uso", "nav.colori": "Colori", "nav.ritiri": "Da portare al tavolo",
    "w.overline": "Ingressi",
    "w.title": "Lista d'attesa",
    "w.sub": "Chi aspetta un tavolo, con il tempo stimato",
    "w.avgTurn": "Un tavolo si libera in media in {n} minuti",
    "w.freeNow": "{n} tavoli liberi ora",
    "w.add": "Metti in lista",
    "w.name": "Nome", "w.people": "Persone", "w.phone": "Telefono",
    "w.note": "Nota", "w.notePh": "Vuole il dehors, ha il cane, seggiolone…",
    "w.addBtn": "Aggiungi", "w.needName": "Indica il nome del cliente",
    "w.added": "Aggiunto in lista d'attesa",
    "w.queue": "In attesa ({n})",
    "w.empty": "Nessuno in attesa: la sala respira.",
    "w.pers": "pers.", "w.since": "in attesa da {n}′",
    "w.table": "tavolo previsto {table}",
    "w.now": "Subito", "w.noTable": "Nessun tavolo adatto",
    "w.notify": "Avvisa", "w.seat": "Accomoda", "w.gone": "Andato via",
    "w.notified": "{name} avvisato", "w.seated": "{name} accomodato",
    "w.alreadyNotified": "già avvisato",
    "w.smsBody": "Ciao {name}, il tuo tavolo è pronto: ti aspettiamo!",
    "w.done": "Chiusi stasera",
    "w.seatedAt": "accomodato al {table}",
    "nav.caso-studio": "Caso studio (interno)",
    "rs.overline": "Gestionale ristorazione",
    "rs.sala": "Sala", "rs.direzione": "Direzione", "rs.reparti": "Reparti",
    "rs.hint": "entra con il tuo PIN a 4 cifre. Chi lavora in Cucina, Pizzeria o Bar arriva direttamente sul monitor del proprio reparto.",
    "rs.demoHint": "questa è una demo, quindi il PIN di ogni persona è scritto sulla sua scheda: tocca «Entra» e sei dentro. Chi lavora in Cucina, Pizzeria o Bar arriva direttamente sul monitor del proprio reparto.",
    "rs.demoNote": "Nella tua vera attività i PIN restano nascosti: li vedi qui solo perché è una demo.",
    "rs.demoPin": "PIN della demo: {pin}",
    "rs.enter": "Entra", "rs.enterPin": "Inserisci PIN",
    "rs.change": "cambia persona", "rs.badPin": "PIN non corretto",
    "rs.empty": "Nessuna persona attiva in questo gruppo.",
    "rs.trialReady": "La tua demo configurata è pronta per {days} giorni",
    "rs.trialBack": "Per rientrare più tardi: attività",
    "rs.trialCode": "codice", "rs.trialKeep": "conservalo.",
    "n.ready": "{name} pronto — tavolo {tables}",
    "n.pickup": "Giro {giro} pronto — tavolo {tables}: {n} piatti da portare",
    "n.pickupLate": "Nessuno ha preso il giro {giro} del tavolo {tables}: pronto da {min} minuti",
    "n.call": "Ti chiamano dalla {dept} — tavolo {tables}",
    "n.handover": "Incasso {tables} {amount} € da {by}: confermi che li hai tu?",
    "n.handin": "{name} ha versato {amount} € in cassa",
    "x.cash.perZone": "Incassi per zona", "x.cash.floats": "Fondi cassa dei camerieri",
    "x.cash.floatsNone": "Nessuno ha un fondo cassa. Assegnalo qui sotto o dalla scheda della persona.",
    "x.cash.inHand": "in mano ora", "x.cash.toHandIn": "da versare",
    "x.cash.handedIn": "già versati", "x.cash.handIn": "Versa in cassa",
    "x.cash.handInOk": "Versamento registrato", "x.cash.handInAmount": "Quanto versi",
    "x.cash.setFloats": "Assegna il fondo a tutta la sala", "x.cash.setFloatsOk": "Fondo cassa assegnato a {n} persone",
    "x.cash.floatsTotal": "Totale fondi", "x.cash.toHandInTotal": "Da versare in cassa",
    "x.cash.closing": "Quadratura di fine serata", "x.cash.printClosing": "Stampa la quadratura",
    "x.cash.cashWord": "Contanti", "x.cash.otherWord": "Carta e altro",
    "x.cash.signature": "Firma di chi chiude la cassa:", "x.cash.popups": "Consenti le finestre popup per stampare",
    "dp.float": "Fondo cassa", "dp.floatOn": "Incassa con un suo fondo",
    "dp.floatAmount": "Fondo assegnato", "dp.floatSaved": "Fondo cassa aggiornato",
    "n.suspended": "Asporto sospeso da {by}: {reason}",
    "n.resumed": "Asporto riaperto da {by}",
    "n.cancelled": "ANNULLATO: {qty}× {name} — {tables} ({reason})",
    "n.chatSuspended": "Asporto sospeso: {reason}",
    "n.chatResumed": "Asporto riaperto: si riprende a prendere ordini",
    "n.empty": "Nessun avviso.",
    "n.freeTable": "Tavolo {table} libero: chiama {name} ({people} pers.) dalla lista d'attesa",
    "x.counter.btn": "Vendita al banco", "x.counter.ok": "Comanda al banco aperta",
    "x.counter.hint": "Senza tavolo e senza coperti: tutto parte subito verso i reparti.",
    "x.extra.title": "Ingredienti extra", "x.extra.add": "Aggiungi con extra",
    "x.extra.each": "+{n} € ciascuno", "x.extra.none": "Nessun extra selezionato",
    "x.weight.title": "Quanti grammi?", "x.weight.grams": "Grammi",
    "x.weight.perKg": "{amount} al chilo", "x.weight.cooking": "Cottura",
    "x.weight.add": "Aggiungi al carrello", "x.weight.needGrams": "Indica i grammi",
    "x.weight.price": "Prezzo calcolato: {amount}",
    "x.opt.takeaway": "Asporto", "x.opt.cut": "Da tagliare",
    "x.cancel.btn": "Annulla", "x.cancel.title": "Annulla {name}", "x.cancel.reason": "Motivo dell'annullo",
    "x.cancel.confirm": "Conferma annullo", "x.cancel.ok": "Piatto annullato e registrato negli sprechi",
    "x.waste.overline": "Controllo costi", "x.waste.title": "Sprechi e annulli",
    "x.waste.total": "Valore annullato", "x.waste.dishes": "Piatti annullati",
    "x.waste.perReason": "Per motivo", "x.waste.rows": "Registro degli annulli",
    "x.waste.none": "Nessun annullo registrato nel periodo.",
    "x.waste.prepared": "già preparato", "x.waste.notPrepared": "non preparato",
    "x.waste.days": "Ultimi {n} giorni",
    "x.hand.title": "Passa l'incasso a un collega", "x.hand.to": "A chi lo consegni",
    "x.hand.send": "Manda l'incasso", "x.hand.sent": "Incasso passato: resta in attesa della conferma",
    "x.hand.pending": "In attesa di conferma da {name}", "x.hand.pick": "Scegli la persona",
    "x.cash.overline": "Cassa", "x.cash.title": "Report della serata",
    "x.cash.sold": "Totale venduto", "x.cash.cashed": "Totale incassato",
    "x.cash.pendingTotal": "Incassi da confermare", "x.cash.perMethod": "Contanti, carta e altro",
    "x.cash.perPerson": "Incassi per persona", "x.cash.thirdParty": "di cui per conto terzi",
    "x.cash.movements": "Movimenti della cassa", "x.cash.confirm": "Confermo, li ho io",
    "x.cash.confirmed": "Incasso confermato a tuo nome", "x.cash.noRows": "Nessun incasso registrato.",
    "x.cash.count": "Conteggio contanti", "x.cash.counted": "Contanti contati",
    "x.cash.float": "Fondo cassa iniziale", "x.cash.expected": "Attesi in cassa",
    "x.cash.registered": "Contanti registrati", "x.cash.diff": "Differenza",
    "x.cash.saveCount": "Registra il conteggio", "x.cash.countOk": "Conteggio registrato",
    "x.cash.countedBy": "contati da {name}", "x.cash.date": "Data",
    "x.dough.title": "Palline di impasto", "x.dough.today": "Palline di oggi",
    "x.dough.left": "restano {n}", "x.dough.used": "usate {n}", "x.dough.set": "Imposta",
    "x.dough.off": "Non impostate: inserisci le palline disponibili a inizio servizio.",
    "x.dough.ok": "Palline aggiornate",
    "x.susp.on": "Sospendi asporto", "x.susp.off": "Riprendi asporto",
    "x.susp.reason": "Motivo (forno pieno, troppe comande…)",
    "x.susp.suspended": "Asporto sospeso: {reason}", "x.susp.ok": "Asporto sospeso: la sala è avvisata",
    "x.susp.resumed": "Asporto riaperto", "x.susp.confirm": "Conferma sospensione",
    "x.claim.go": "Ci vado io", "x.claim.going": "Ci va {name}", "x.claim.help": "Aiuta un collega",
    "x.chat.room": "Sala", "x.chat.private": "Privata", "x.chat.pick": "Scegli il collega",
    "x.chat.ph": "Scrivi un messaggio",
    "x.bk.overline": "Sicurezza dei dati", "x.bk.title": "Backup e ripristino",
    "gdpr.title": "I tuoi dati", "gdpr.word": "ELIMINA",
    "gdpr.sub": "Sono tuoi: puoi portarteli via quando vuoi o farli cancellare del tutto.",
    "gdpr.p1": "Scarica in qualsiasi momento un file con tutti i dati del locale (pulsante «Scarica backup»).",
    "gdpr.p2": "I dati del tuo locale sono separati da quelli di ogni altro cliente e le copie notturne sono cifrate.",
    "gdpr.p3": "Codice attività e PIN sono salvati solo come impronta cifrata: non sono leggibili da nessuno.",
    "gdpr.delete": "Cancella il mio locale",
    "gdpr.warn": "Operazione definitiva: scarica prima la tua copia dei dati. Ti mandiamo un'email di conferma e non tocchiamo nulla finché non confermi.",
    "gdpr.email": "Email registrata per questa attività",
    "gdpr.type": "Scrivi {word} per procedere",
    "gdpr.send": "Mandami l'email di conferma",
    "gdpr.cancel": "Lascia stare",
    "gdpr.sent": "Email di conferma inviata a {mail}",
    "x.bk.download": "Scarica i dati", "x.bk.downloaded": "Backup scaricato",
    "x.bk.restore": "Ripristina da file", "x.bk.restoreOk": "Dati ripristinati",
    "x.bk.warn": "Il ripristino sovrascrive i dati attuali. Prima viene creata automaticamente una copia di sicurezza.",
    "x.bk.records": "record", "x.bk.history": "Ripristini effettuati",
    "x.bk.pick": "Scegli il file di backup", "x.bk.bad": "File di backup non valido",
    "x.bk.content": "Cosa contiene il backup",
    "x.off.banner": "Sei offline: sola lettura, i dati sono dell'ultimo aggiornamento.",
    "beta.tag": "Versione BETA in sviluppo",
    "beta.long": "— stiamo ancora costruendo alcune parti: se trovi qualcosa che non ti torna, scrivicelo.",
    "beta.cta": "Dai il tuo parere",
    "beta.notice": "Questa è una versione beta in fase di sviluppo: alcune parti cambieranno ancora. Se la provi, mi farebbe piacere sapere cosa ne pensi.",
    "fb.fab": "Il tuo parere",
    "fb.title": "Com'è andata la prova?",
    "fb.intro": "Reprehendo è in versione beta: il tuo parere decide cosa costruiamo per primo. Un minuto, sei domande.",
    "fb.q1": "Voto complessivo",
    "fb.q2": "Quanto è facile da usare",
    "fb.q3": "La parte che ti è piaciuta di più",
    "fb.q4": "Cosa manca o cosa cambieresti?",
    "fb.q4ph": "Scrivi liberamente: è la risposta che ci serve di più.",
    "fb.q5": "La useresti nel tuo locale?",
    "fb.q6": "Email (facoltativa) se vuoi che ti aggiorniamo",
    "fb.q6note": "Nessuna newsletter: solo per rispondere al tuo consiglio.",
    "fb.yes": "Sì", "fb.maybe": "Forse", "fb.no": "No",
    "fb.send": "Invia il questionario",
    "fb.needRating": "Dai almeno il voto complessivo",
    "fb.thanks": "Grazie, ricevuto!",
    "fb.thanksSub": "Ogni consiglio finisce nella lista delle prossime cose da fare.",
    "fb.close": "Chiudi",
  },
  en: {
    "nav.cassa": "Till and takings", "nav.sprechi": "Waste and voids", "nav.backup": "Backup and restore",
    "nav.attesa": "Waiting list", "nav.piatti-giorno": "Today's dishes", "nav.guida": "Quick guide", "nav.manuale": "User manual", "nav.colori": "Colours", "nav.ritiri": "To bring to the table",
    "w.overline": "Walk-ins",
    "w.title": "Waiting list",
    "w.sub": "Who is waiting for a table, with the estimated wait",
    "w.avgTurn": "A table frees up in {n} minutes on average",
    "w.freeNow": "{n} tables free right now",
    "w.add": "Add to the list",
    "w.name": "Name", "w.people": "People", "w.phone": "Phone",
    "w.note": "Note", "w.notePh": "Wants the terrace, has a dog, highchair…",
    "w.addBtn": "Add", "w.needName": "Enter the guest's name",
    "w.added": "Added to the waiting list",
    "w.queue": "Waiting ({n})",
    "w.empty": "Nobody waiting: the floor can breathe.",
    "w.pers": "people", "w.since": "waiting for {n}′",
    "w.table": "expected table {table}",
    "w.now": "Right away", "w.noTable": "No suitable table",
    "w.notify": "Notify", "w.seat": "Seat", "w.gone": "Left",
    "w.notified": "{name} notified", "w.seated": "{name} seated",
    "w.alreadyNotified": "already notified",
    "w.smsBody": "Hi {name}, your table is ready: we are waiting for you!",
    "w.done": "Closed tonight",
    "w.seatedAt": "seated at {table}",
    "nav.caso-studio": "Case study (internal)",
    "rs.overline": "Restaurant management",
    "rs.sala": "Floor", "rs.direzione": "Management", "rs.reparti": "Stations",
    "rs.hint": "sign in with your 4-digit PIN. Kitchen, pizzeria and bar staff go straight to their station monitor.",
    "rs.demoHint": "this is a demo, so each person's PIN is printed on their card: tap “Enter” and you are in. Kitchen, pizzeria and bar staff go straight to their station monitor.",
    "rs.demoNote": "In your real venue the PINs stay hidden: you only see them here because this is a demo.",
    "rs.demoPin": "Demo PIN: {pin}",
    "rs.enter": "Enter", "rs.enterPin": "Enter PIN",
    "rs.change": "change person", "rs.badPin": "Wrong PIN",
    "rs.empty": "No active person in this group.",
    "rs.trialReady": "Your configured demo is ready for {days} days",
    "rs.trialBack": "To get back in later: venue",
    "rs.trialCode": "code", "rs.trialKeep": "keep it safe.",
    "n.ready": "{name} ready — table {tables}",
    "n.pickup": "Round {giro} ready — table {tables}: {n} dishes to bring",
    "n.pickupLate": "Nobody took round {giro} for table {tables}: ready {min} minutes ago",
    "n.call": "You are called from the {dept} — table {tables}",
    "n.handover": "Takings {tables} {amount} € from {by}: do you confirm you have it?",
    "n.handin": "{name} handed in {amount} € to the till",
    "x.cash.perZone": "Takings per area", "x.cash.floats": "Waiter cash floats",
    "x.cash.floatsNone": "Nobody has a float yet. Assign one below or from the person's card.",
    "x.cash.inHand": "in hand now", "x.cash.toHandIn": "to hand in",
    "x.cash.handedIn": "already handed in", "x.cash.handIn": "Hand in to the till",
    "x.cash.handInOk": "Hand-in recorded", "x.cash.handInAmount": "How much you hand in",
    "x.cash.setFloats": "Give the whole floor a float", "x.cash.setFloatsOk": "Float assigned to {n} people",
    "x.cash.floatsTotal": "Total floats", "x.cash.toHandInTotal": "To hand in to the till",
    "x.cash.closing": "End-of-shift reconciliation", "x.cash.printClosing": "Print the reconciliation",
    "x.cash.cashWord": "Cash", "x.cash.otherWord": "Card and other",
    "x.cash.signature": "Signed by whoever closes the till:", "x.cash.popups": "Allow pop-ups to print",
    "dp.float": "Cash float", "dp.floatOn": "Takes payments with own float",
    "dp.floatAmount": "Float given", "dp.floatSaved": "Cash float updated",
    "n.suspended": "Takeaway suspended by {by}: {reason}",
    "n.resumed": "Takeaway resumed by {by}",
    "n.cancelled": "VOIDED: {qty}× {name} — {tables} ({reason})",
    "n.chatSuspended": "Takeaway suspended: {reason}",
    "n.chatResumed": "Takeaway resumed: we are taking orders again",
    "n.empty": "No alerts.",
    "n.freeTable": "Table {table} free: call {name} ({people} people) from the waiting list",
    "x.counter.btn": "Counter sale", "x.counter.ok": "Counter order opened",
    "x.counter.hint": "No table, no covers: everything goes straight to the stations.",
    "x.extra.title": "Extra toppings", "x.extra.add": "Add with extras",
    "x.extra.each": "+{n} € each", "x.extra.none": "No extras selected",
    "x.weight.title": "How many grams?", "x.weight.grams": "Grams",
    "x.weight.perKg": "{amount} per kilo", "x.weight.cooking": "Cooking",
    "x.weight.add": "Add to cart", "x.weight.needGrams": "Enter the grams",
    "x.weight.price": "Calculated price: {amount}",
    "x.opt.takeaway": "Takeaway", "x.opt.cut": "To be sliced",
    "x.cancel.btn": "Void", "x.cancel.title": "Void {name}", "x.cancel.reason": "Reason for the void",
    "x.cancel.confirm": "Confirm void", "x.cancel.ok": "Dish voided and logged as waste",
    "x.waste.overline": "Cost control", "x.waste.title": "Waste and voids",
    "x.waste.total": "Voided value", "x.waste.dishes": "Voided dishes",
    "x.waste.perReason": "By reason", "x.waste.rows": "Void log",
    "x.waste.none": "No voids recorded in this period.",
    "x.waste.prepared": "already prepared", "x.waste.notPrepared": "not prepared",
    "x.waste.days": "Last {n} days",
    "x.hand.title": "Hand the takings to a colleague", "x.hand.to": "Who is taking it",
    "x.hand.send": "Send the takings", "x.hand.sent": "Takings handed over: waiting for confirmation",
    "x.hand.pending": "Waiting for {name} to confirm", "x.hand.pick": "Pick the person",
    "x.cash.overline": "Till", "x.cash.title": "Shift report",
    "x.cash.sold": "Total sold", "x.cash.cashed": "Total taken",
    "x.cash.pendingTotal": "Takings to confirm", "x.cash.perMethod": "Cash, card and other",
    "x.cash.perPerson": "Takings per person", "x.cash.thirdParty": "of which on behalf of others",
    "x.cash.movements": "Till movements", "x.cash.confirm": "Confirmed, I have it",
    "x.cash.confirmed": "Takings confirmed under your name", "x.cash.noRows": "No takings recorded.",
    "x.cash.count": "Cash count", "x.cash.counted": "Cash counted",
    "x.cash.float": "Opening float", "x.cash.expected": "Expected in the till",
    "x.cash.registered": "Registered cash", "x.cash.diff": "Difference",
    "x.cash.saveCount": "Record the count", "x.cash.countOk": "Count recorded",
    "x.cash.countedBy": "counted by {name}", "x.cash.date": "Date",
    "x.dough.title": "Dough balls", "x.dough.today": "Today's dough balls",
    "x.dough.left": "{n} left", "x.dough.used": "{n} used", "x.dough.set": "Set",
    "x.dough.off": "Not set: enter the dough balls available at the start of service.",
    "x.dough.ok": "Dough balls updated",
    "x.susp.on": "Suspend takeaway", "x.susp.off": "Resume takeaway",
    "x.susp.reason": "Reason (oven full, too many orders…)",
    "x.susp.suspended": "Takeaway suspended: {reason}", "x.susp.ok": "Takeaway suspended: the floor is notified",
    "x.susp.resumed": "Takeaway resumed", "x.susp.confirm": "Confirm suspension",
    "x.claim.go": "I'll go", "x.claim.going": "{name} is going", "x.claim.help": "Help a colleague",
    "x.chat.room": "Floor", "x.chat.private": "Private", "x.chat.pick": "Pick a colleague",
    "x.chat.ph": "Write a message",
    "x.bk.overline": "Data safety", "x.bk.title": "Backup and restore",
    "gdpr.title": "Your data", "gdpr.word": "DELETE",
    "gdpr.sub": "It is yours: take it with you whenever you want, or have it deleted for good.",
    "gdpr.p1": "Download a file with all your venue data at any time (the “Download backup” button).",
    "gdpr.p2": "Your venue data is kept apart from every other customer and nightly copies are encrypted.",
    "gdpr.p3": "Venue code and PINs are stored only as an encrypted fingerprint: nobody can read them.",
    "gdpr.delete": "Delete my venue",
    "gdpr.warn": "This is permanent: download your copy first. We send a confirmation email and touch nothing until you confirm.",
    "gdpr.email": "Email registered for this venue",
    "gdpr.type": "Type {word} to continue",
    "gdpr.send": "Send me the confirmation email",
    "gdpr.cancel": "Never mind",
    "gdpr.sent": "Confirmation email sent to {mail}",
    "x.bk.download": "Download the data", "x.bk.downloaded": "Backup downloaded",
    "x.bk.restore": "Restore from file", "x.bk.restoreOk": "Data restored",
    "x.bk.warn": "Restoring overwrites current data. A safety copy is created automatically first.",
    "x.bk.records": "records", "x.bk.history": "Restores performed",
    "x.bk.pick": "Choose the backup file", "x.bk.bad": "Invalid backup file",
    "x.bk.content": "What the backup contains",
    "x.off.banner": "You are offline: read only, data is from the last update.",
    "beta.tag": "BETA version in development",
    "beta.long": "— some parts are still being built: if something feels off, tell us.",
    "beta.cta": "Give your feedback",
    "beta.notice": "This is a beta version under development: some parts will still change. If you try it, I would love to know what you think.",
    "fb.fab": "Your feedback",
    "fb.title": "How did the trial go?",
    "fb.intro": "Reprehendo is in beta: your feedback decides what we build first. One minute, six questions.",
    "fb.q1": "Overall rating",
    "fb.q2": "How easy is it to use",
    "fb.q3": "The part you liked most",
    "fb.q4": "What is missing or what would you change?",
    "fb.q4ph": "Write freely: this is the answer we need most.",
    "fb.q5": "Would you use it in your venue?",
    "fb.q6": "Email (optional) if you want updates",
    "fb.q6note": "No newsletter: only to reply to your feedback.",
    "fb.yes": "Yes", "fb.maybe": "Maybe", "fb.no": "No",
    "fb.send": "Send the questionnaire",
    "fb.needRating": "Please give at least the overall rating",
    "fb.thanks": "Thank you, received!",
    "fb.thanksSub": "Every suggestion goes straight into our to-do list.",
    "fb.close": "Close",
  },
  fr: {
    "nav.cassa": "Caisse et recettes", "nav.sprechi": "Pertes et annulations", "nav.backup": "Sauvegarde et restauration",
    "nav.attesa": "Liste d'attente", "nav.piatti-giorno": "Plats du jour", "nav.guida": "Guide rapide", "nav.manuale": "Manuel d'utilisation", "nav.colori": "Couleurs", "nav.ritiri": "À apporter en salle",
    "w.overline": "Arrivées",
    "w.title": "Liste d'attente",
    "w.sub": "Qui attend une table, avec le temps estimé",
    "w.avgTurn": "Une table se libère en moyenne en {n} minutes",
    "w.freeNow": "{n} tables libres maintenant",
    "w.add": "Ajouter à la liste",
    "w.name": "Nom", "w.people": "Personnes", "w.phone": "Téléphone",
    "w.note": "Note", "w.notePh": "Veut la terrasse, a un chien, chaise haute…",
    "w.addBtn": "Ajouter", "w.needName": "Indiquez le nom du client",
    "w.added": "Ajouté à la liste d'attente",
    "w.queue": "En attente ({n})",
    "w.empty": "Personne n'attend : la salle respire.",
    "w.pers": "pers.", "w.since": "attend depuis {n}′",
    "w.table": "table prévue {table}",
    "w.now": "Tout de suite", "w.noTable": "Aucune table adaptée",
    "w.notify": "Prévenir", "w.seat": "Installer", "w.gone": "Parti",
    "w.notified": "{name} prévenu", "w.seated": "{name} installé",
    "w.alreadyNotified": "déjà prévenu",
    "w.smsBody": "Bonjour {name}, votre table est prête : nous vous attendons !",
    "w.done": "Clôturés ce soir",
    "w.seatedAt": "installé à la {table}",
    "nav.caso-studio": "Étude de cas (interne)",
    "rs.overline": "Gestion de restaurant",
    "rs.sala": "Salle", "rs.direzione": "Direction", "rs.reparti": "Postes",
    "rs.hint": "connectez-vous avec votre code à 4 chiffres. La cuisine, la pizzeria et le bar arrivent directement sur l'écran de leur poste.",
    "rs.demoHint": "ceci est une démo : le code de chaque personne est indiqué sur sa fiche, touchez « Entrer » et c'est parti. La cuisine, la pizzeria et le bar arrivent directement sur l'écran de leur poste.",
    "rs.demoNote": "Dans votre véritable établissement les codes restent masqués : ils ne sont visibles ici que parce qu'il s'agit d'une démo.",
    "rs.demoPin": "Code de la démo : {pin}",
    "rs.enter": "Entrer", "rs.enterPin": "Saisir le code",
    "rs.change": "changer de personne", "rs.badPin": "Code incorrect",
    "rs.empty": "Aucune personne active dans ce groupe.",
    "rs.trialReady": "Votre démo configurée est prête pour {days} jours",
    "rs.trialBack": "Pour revenir plus tard : établissement",
    "rs.trialCode": "code", "rs.trialKeep": "conservez-le.",
    "n.ready": "{name} prêt — table {tables}",
    "n.pickup": "Tour {giro} prêt — table {tables} : {n} plats à apporter",
    "n.pickupLate": "Personne n'a pris le tour {giro} de la table {tables} : prêt depuis {min} minutes",
    "n.call": "On vous appelle de la {dept} — table {tables}",
    "n.handover": "Recette {tables} {amount} € de {by} : confirmez-vous que vous l'avez ?",
    "n.handin": "{name} a versé {amount} € en caisse",
    "x.cash.perZone": "Recettes par zone", "x.cash.floats": "Fonds de caisse des serveurs",
    "x.cash.floatsNone": "Personne n'a de fonds de caisse. Attribuez-le ci-dessous ou sur la fiche de la personne.",
    "x.cash.inHand": "en main maintenant", "x.cash.toHandIn": "à verser",
    "x.cash.handedIn": "déjà versés", "x.cash.handIn": "Verser en caisse",
    "x.cash.handInOk": "Versement enregistré", "x.cash.handInAmount": "Montant versé",
    "x.cash.setFloats": "Attribuer le fonds à toute la salle", "x.cash.setFloatsOk": "Fonds attribué à {n} personnes",
    "x.cash.floatsTotal": "Total des fonds", "x.cash.toHandInTotal": "À verser en caisse",
    "x.cash.closing": "Clôture de fin de service", "x.cash.printClosing": "Imprimer la clôture",
    "x.cash.cashWord": "Espèces", "x.cash.otherWord": "Carte et autre",
    "x.cash.signature": "Signature de la personne qui clôture :", "x.cash.popups": "Autorisez les fenêtres pop-up pour imprimer",
    "dp.float": "Fonds de caisse", "dp.floatOn": "Encaisse avec son propre fonds",
    "dp.floatAmount": "Fonds attribué", "dp.floatSaved": "Fonds de caisse mis à jour",
    "n.suspended": "Vente à emporter suspendue par {by} : {reason}",
    "n.resumed": "Vente à emporter reprise par {by}",
    "n.cancelled": "ANNULÉ : {qty}× {name} — {tables} ({reason})",
    "n.chatSuspended": "Vente à emporter suspendue : {reason}",
    "n.chatResumed": "Vente à emporter reprise : nous acceptons de nouveau les commandes",
    "n.empty": "Aucune alerte.",
    "n.freeTable": "Table {table} libre : appelez {name} ({people} pers.) de la liste d'attente",
    "x.counter.btn": "Vente au comptoir", "x.counter.ok": "Commande au comptoir ouverte",
    "x.counter.hint": "Sans table ni couverts : tout part immédiatement vers les postes.",
    "x.extra.title": "Ingrédients supplémentaires", "x.extra.add": "Ajouter avec extras",
    "x.extra.each": "+{n} € chacun", "x.extra.none": "Aucun extra sélectionné",
    "x.weight.title": "Combien de grammes ?", "x.weight.grams": "Grammes",
    "x.weight.perKg": "{amount} le kilo", "x.weight.cooking": "Cuisson",
    "x.weight.add": "Ajouter au panier", "x.weight.needGrams": "Indiquez les grammes",
    "x.weight.price": "Prix calculé : {amount}",
    "x.opt.takeaway": "À emporter", "x.opt.cut": "À couper",
    "x.cancel.btn": "Annuler", "x.cancel.title": "Annuler {name}", "x.cancel.reason": "Motif de l'annulation",
    "x.cancel.confirm": "Confirmer l'annulation", "x.cancel.ok": "Plat annulé et enregistré dans les pertes",
    "x.waste.overline": "Contrôle des coûts", "x.waste.title": "Pertes et annulations",
    "x.waste.total": "Valeur annulée", "x.waste.dishes": "Plats annulés",
    "x.waste.perReason": "Par motif", "x.waste.rows": "Registre des annulations",
    "x.waste.none": "Aucune annulation sur la période.",
    "x.waste.prepared": "déjà préparé", "x.waste.notPrepared": "non préparé",
    "x.waste.days": "Derniers {n} jours",
    "x.hand.title": "Confier la recette à un collègue", "x.hand.to": "À qui vous la confiez",
    "x.hand.send": "Envoyer la recette", "x.hand.sent": "Recette transmise : en attente de confirmation",
    "x.hand.pending": "En attente de la confirmation de {name}", "x.hand.pick": "Choisissez la personne",
    "x.cash.overline": "Caisse", "x.cash.title": "Rapport du service",
    "x.cash.sold": "Total vendu", "x.cash.cashed": "Total encaissé",
    "x.cash.pendingTotal": "Recettes à confirmer", "x.cash.perMethod": "Espèces, carte et autre",
    "x.cash.perPerson": "Recettes par personne", "x.cash.thirdParty": "dont pour le compte d'autrui",
    "x.cash.movements": "Mouvements de caisse", "x.cash.confirm": "Confirmé, je les ai",
    "x.cash.confirmed": "Recette confirmée à votre nom", "x.cash.noRows": "Aucune recette enregistrée.",
    "x.cash.count": "Comptage des espèces", "x.cash.counted": "Espèces comptées",
    "x.cash.float": "Fond de caisse initial", "x.cash.expected": "Attendu en caisse",
    "x.cash.registered": "Espèces enregistrées", "x.cash.diff": "Écart",
    "x.cash.saveCount": "Enregistrer le comptage", "x.cash.countOk": "Comptage enregistré",
    "x.cash.countedBy": "compté par {name}", "x.cash.date": "Date",
    "x.dough.title": "Pâtons", "x.dough.today": "Pâtons du jour",
    "x.dough.left": "{n} restants", "x.dough.used": "{n} utilisés", "x.dough.set": "Définir",
    "x.dough.off": "Non défini : saisissez les pâtons disponibles en début de service.",
    "x.dough.ok": "Pâtons mis à jour",
    "x.susp.on": "Suspendre la vente à emporter", "x.susp.off": "Reprendre la vente à emporter",
    "x.susp.reason": "Motif (four plein, trop de commandes…)",
    "x.susp.suspended": "Vente à emporter suspendue : {reason}", "x.susp.ok": "Vente à emporter suspendue : la salle est prévenue",
    "x.susp.resumed": "Vente à emporter reprise", "x.susp.confirm": "Confirmer la suspension",
    "x.claim.go": "J'y vais", "x.claim.going": "{name} y va", "x.claim.help": "Aidez un collègue",
    "x.chat.room": "Salle", "x.chat.private": "Privée", "x.chat.pick": "Choisissez le collègue",
    "x.chat.ph": "Écrivez un message",
    "x.bk.overline": "Sécurité des données", "x.bk.title": "Sauvegarde et restauration",
    "gdpr.title": "Vos données", "gdpr.word": "SUPPRIMER",
    "gdpr.sub": "Elles sont à vous : emportez-les quand vous voulez ou faites-les supprimer définitivement.",
    "gdpr.p1": "Téléchargez à tout moment un fichier avec toutes les données de l'établissement.",
    "gdpr.p2": "Vos données sont séparées de celles des autres clients et les copies de nuit sont chiffrées.",
    "gdpr.p3": "Le code de l'établissement et les codes PIN ne sont conservés que sous forme d'empreinte chiffrée.",
    "gdpr.delete": "Supprimer mon établissement",
    "gdpr.warn": "Opération définitive : téléchargez d'abord votre copie. Nous envoyons un e-mail de confirmation et ne touchons à rien avant votre accord.",
    "gdpr.email": "E-mail enregistré pour cet établissement",
    "gdpr.type": "Écrivez {word} pour continuer",
    "gdpr.send": "Envoyez-moi l'e-mail de confirmation",
    "gdpr.cancel": "Laisser tomber",
    "gdpr.sent": "E-mail de confirmation envoyé à {mail}",
    "x.bk.download": "Télécharger les données", "x.bk.downloaded": "Sauvegarde téléchargée",
    "x.bk.restore": "Restaurer depuis un fichier", "x.bk.restoreOk": "Données restaurées",
    "x.bk.warn": "La restauration écrase les données actuelles. Une copie de sécurité est créée automatiquement avant.",
    "x.bk.records": "enregistrements", "x.bk.history": "Restaurations effectuées",
    "x.bk.pick": "Choisissez le fichier de sauvegarde", "x.bk.bad": "Fichier de sauvegarde non valide",
    "x.bk.content": "Contenu de la sauvegarde",
    "x.off.banner": "Vous êtes hors ligne : lecture seule, données de la dernière mise à jour.",
    "beta.tag": "Version BÊTA en développement",
    "beta.long": "— certaines parties sont encore en construction : si quelque chose ne va pas, dites-le nous.",
    "beta.cta": "Donnez votre avis",
    "beta.notice": "Ceci est une version bêta en développement : certaines parties vont encore changer. Si vous l'essayez, votre avis me ferait très plaisir.",
    "fb.fab": "Votre avis",
    "fb.title": "Comment s'est passé l'essai ?",
    "fb.intro": "Reprehendo est en version bêta : votre avis décide de ce que nous construisons en premier. Une minute, six questions.",
    "fb.q1": "Note globale",
    "fb.q2": "Facilité d'utilisation",
    "fb.q3": "La partie que vous avez préférée",
    "fb.q4": "Qu'est-ce qui manque ou que changeriez-vous ?",
    "fb.q4ph": "Écrivez librement : c'est la réponse dont nous avons le plus besoin.",
    "fb.q5": "L'utiliseriez-vous dans votre établissement ?",
    "fb.q6": "E-mail (facultatif) pour recevoir des nouvelles",
    "fb.q6note": "Pas de newsletter : uniquement pour répondre à votre avis.",
    "fb.yes": "Oui", "fb.maybe": "Peut-être", "fb.no": "Non",
    "fb.send": "Envoyer le questionnaire",
    "fb.needRating": "Donnez au moins la note globale",
    "fb.thanks": "Merci, bien reçu !",
    "fb.thanksSub": "Chaque conseil rejoint la liste des prochaines choses à faire.",
    "fb.close": "Fermer",
  },
  de: {
    "nav.cassa": "Kasse und Einnahmen", "nav.sprechi": "Verluste und Storni", "nav.backup": "Backup und Wiederherstellung",
    "nav.attesa": "Warteliste", "nav.piatti-giorno": "Tagesgerichte", "nav.guida": "Kurzanleitung", "nav.manuale": "Handbuch", "nav.colori": "Farben", "nav.ritiri": "Zum Tisch bringen",
    "w.overline": "Laufkundschaft",
    "w.title": "Warteliste",
    "w.sub": "Wer auf einen Tisch wartet, mit geschätzter Wartezeit",
    "w.avgTurn": "Ein Tisch wird durchschnittlich in {n} Minuten frei",
    "w.freeNow": "{n} Tische jetzt frei",
    "w.add": "Auf die Liste setzen",
    "w.name": "Name", "w.people": "Personen", "w.phone": "Telefon",
    "w.note": "Notiz", "w.notePh": "Möchte die Terrasse, hat einen Hund, Hochstuhl…",
    "w.addBtn": "Hinzufügen", "w.needName": "Name des Gastes angeben",
    "w.added": "Zur Warteliste hinzugefügt",
    "w.queue": "Wartend ({n})",
    "w.empty": "Niemand wartet: der Saal kann atmen.",
    "w.pers": "Pers.", "w.since": "wartet seit {n}′",
    "w.table": "vorgesehener Tisch {table}",
    "w.now": "Sofort", "w.noTable": "Kein passender Tisch",
    "w.notify": "Benachrichtigen", "w.seat": "Platzieren", "w.gone": "Gegangen",
    "w.notified": "{name} benachrichtigt", "w.seated": "{name} platziert",
    "w.alreadyNotified": "bereits benachrichtigt",
    "w.smsBody": "Hallo {name}, Ihr Tisch ist bereit: wir warten auf Sie!",
    "w.done": "Heute Abend abgeschlossen",
    "w.seatedAt": "platziert an {table}",
    "nav.caso-studio": "Fallstudie (intern)",
    "rs.overline": "Gastronomie-Verwaltung",
    "rs.sala": "Saal", "rs.direzione": "Leitung", "rs.reparti": "Stationen",
    "rs.hint": "melden Sie sich mit Ihrer 4-stelligen PIN an. Küche, Pizzeria und Bar landen direkt auf dem Monitor ihrer Station.",
    "rs.demoHint": "das ist eine Demo, deshalb steht die PIN jeder Person auf ihrer Karte: auf „Eintreten“ tippen und los. Küche, Pizzeria und Bar landen direkt auf dem Monitor ihrer Station.",
    "rs.demoNote": "In Ihrem echten Betrieb bleiben die PINs verborgen: hier sehen Sie sie nur, weil es eine Demo ist.",
    "rs.demoPin": "Demo-PIN: {pin}",
    "rs.enter": "Eintreten", "rs.enterPin": "PIN eingeben",
    "rs.change": "Person wechseln", "rs.badPin": "Falsche PIN",
    "rs.empty": "Keine aktive Person in dieser Gruppe.",
    "rs.trialReady": "Ihre eingerichtete Demo ist {days} Tage bereit",
    "rs.trialBack": "Für den späteren Einstieg: Betrieb",
    "rs.trialCode": "Code", "rs.trialKeep": "gut aufbewahren.",
    "n.ready": "{name} fertig — Tisch {tables}",
    "n.pickup": "Runde {giro} fertig — Tisch {tables}: {n} Teller zu bringen",
    "n.pickupLate": "Niemand hat Runde {giro} von Tisch {tables} übernommen: fertig seit {min} Minuten",
    "n.call": "Sie werden von der {dept} gerufen — Tisch {tables}",
    "n.handover": "Einnahme {tables} {amount} € von {by}: bestätigen Sie, dass Sie sie haben?",
    "n.handin": "{name} hat {amount} € in die Kasse eingezahlt",
    "x.cash.perZone": "Einnahmen pro Bereich", "x.cash.floats": "Wechselgeld der Kellner",
    "x.cash.floatsNone": "Noch niemand hat Wechselgeld. Unten oder in der Personenkarte zuweisen.",
    "x.cash.inHand": "jetzt in der Hand", "x.cash.toHandIn": "einzuzahlen",
    "x.cash.handedIn": "schon eingezahlt", "x.cash.handIn": "In die Kasse einzahlen",
    "x.cash.handInOk": "Einzahlung erfasst", "x.cash.handInAmount": "Wie viel Sie einzahlen",
    "x.cash.setFloats": "Wechselgeld für den ganzen Service", "x.cash.setFloatsOk": "Wechselgeld an {n} Personen zugewiesen",
    "x.cash.floatsTotal": "Wechselgeld gesamt", "x.cash.toHandInTotal": "In die Kasse einzuzahlen",
    "x.cash.closing": "Tagesabschluss", "x.cash.printClosing": "Abschluss drucken",
    "x.cash.cashWord": "Bar", "x.cash.otherWord": "Karte und andere",
    "x.cash.signature": "Unterschrift des Kassenabschlusses:", "x.cash.popups": "Pop-ups zum Drucken erlauben",
    "dp.float": "Wechselgeld", "dp.floatOn": "Kassiert mit eigenem Wechselgeld",
    "dp.floatAmount": "Zugewiesener Betrag", "dp.floatSaved": "Wechselgeld aktualisiert",
    "n.suspended": "Abholung ausgesetzt von {by}: {reason}",
    "n.resumed": "Abholung fortgesetzt von {by}",
    "n.cancelled": "STORNIERT: {qty}× {name} — {tables} ({reason})",
    "n.chatSuspended": "Abholung ausgesetzt: {reason}",
    "n.chatResumed": "Abholung fortgesetzt: wir nehmen wieder Bestellungen an",
    "n.empty": "Keine Hinweise.",
    "n.freeTable": "Tisch {table} frei: rufen Sie {name} ({people} Pers.) von der Warteliste",
    "x.counter.btn": "Thekenverkauf", "x.counter.ok": "Thekenbestellung geöffnet",
    "x.counter.hint": "Ohne Tisch und Gedecke: alles geht sofort an die Stationen.",
    "x.extra.title": "Extra-Zutaten", "x.extra.add": "Mit Extras hinzufügen",
    "x.extra.each": "+{n} € pro Stück", "x.extra.none": "Keine Extras ausgewählt",
    "x.weight.title": "Wie viele Gramm?", "x.weight.grams": "Gramm",
    "x.weight.perKg": "{amount} pro Kilo", "x.weight.cooking": "Garstufe",
    "x.weight.add": "In den Warenkorb", "x.weight.needGrams": "Gramm angeben",
    "x.weight.price": "Berechneter Preis: {amount}",
    "x.opt.takeaway": "Zum Mitnehmen", "x.opt.cut": "Zu schneiden",
    "x.cancel.btn": "Storno", "x.cancel.title": "{name} stornieren", "x.cancel.reason": "Grund für das Storno",
    "x.cancel.confirm": "Storno bestätigen", "x.cancel.ok": "Gericht storniert und als Verlust erfasst",
    "x.waste.overline": "Kostenkontrolle", "x.waste.title": "Verluste und Storni",
    "x.waste.total": "Stornierter Wert", "x.waste.dishes": "Stornierte Gerichte",
    "x.waste.perReason": "Nach Grund", "x.waste.rows": "Storno-Protokoll",
    "x.waste.none": "Keine Storni im Zeitraum erfasst.",
    "x.waste.prepared": "bereits zubereitet", "x.waste.notPrepared": "nicht zubereitet",
    "x.waste.days": "Letzte {n} Tage",
    "x.hand.title": "Einnahmen an Kollegen übergeben", "x.hand.to": "Wer übernimmt sie",
    "x.hand.send": "Einnahmen senden", "x.hand.sent": "Einnahmen übergeben: warten auf Bestätigung",
    "x.hand.pending": "Warten auf Bestätigung von {name}", "x.hand.pick": "Person auswählen",
    "x.cash.overline": "Kasse", "x.cash.title": "Schichtbericht",
    "x.cash.sold": "Gesamtumsatz", "x.cash.cashed": "Gesamt eingenommen",
    "x.cash.pendingTotal": "Zu bestätigende Einnahmen", "x.cash.perMethod": "Bar, Karte und andere",
    "x.cash.perPerson": "Einnahmen pro Person", "x.cash.thirdParty": "davon für andere",
    "x.cash.movements": "Kassenbewegungen", "x.cash.confirm": "Bestätigt, ich habe sie",
    "x.cash.confirmed": "Einnahme auf Ihren Namen bestätigt", "x.cash.noRows": "Keine Einnahmen erfasst.",
    "x.cash.count": "Bargeldzählung", "x.cash.counted": "Gezähltes Bargeld",
    "x.cash.float": "Anfangsbestand", "x.cash.expected": "Erwartet in der Kasse",
    "x.cash.registered": "Erfasstes Bargeld", "x.cash.diff": "Differenz",
    "x.cash.saveCount": "Zählung erfassen", "x.cash.countOk": "Zählung erfasst",
    "x.cash.countedBy": "gezählt von {name}", "x.cash.date": "Datum",
    "x.dough.title": "Teigballen", "x.dough.today": "Teigballen von heute",
    "x.dough.left": "{n} übrig", "x.dough.used": "{n} verwendet", "x.dough.set": "Festlegen",
    "x.dough.off": "Nicht festgelegt: Teigballen zu Servicebeginn eintragen.",
    "x.dough.ok": "Teigballen aktualisiert",
    "x.susp.on": "Abholung aussetzen", "x.susp.off": "Abholung fortsetzen",
    "x.susp.reason": "Grund (Ofen voll, zu viele Bestellungen…)",
    "x.susp.suspended": "Abholung ausgesetzt: {reason}", "x.susp.ok": "Abholung ausgesetzt: der Saal ist informiert",
    "x.susp.resumed": "Abholung fortgesetzt", "x.susp.confirm": "Aussetzung bestätigen",
    "x.claim.go": "Ich gehe", "x.claim.going": "{name} geht", "x.claim.help": "Kollegen helfen",
    "x.chat.room": "Saal", "x.chat.private": "Privat", "x.chat.pick": "Kollegen auswählen",
    "x.chat.ph": "Nachricht schreiben",
    "x.bk.overline": "Datensicherheit", "x.bk.title": "Backup und Wiederherstellung",
    "gdpr.title": "Ihre Daten", "gdpr.word": "LOESCHEN",
    "gdpr.sub": "Sie gehören Ihnen: jederzeit mitnehmen oder endgültig löschen lassen.",
    "gdpr.p1": "Laden Sie jederzeit eine Datei mit allen Betriebsdaten herunter.",
    "gdpr.p2": "Ihre Daten sind von allen anderen Kunden getrennt, die nächtlichen Kopien sind verschlüsselt.",
    "gdpr.p3": "Betriebscode und PINs werden nur als verschlüsselter Fingerabdruck gespeichert.",
    "gdpr.delete": "Meinen Betrieb löschen",
    "gdpr.warn": "Endgültig: laden Sie zuerst Ihre Kopie herunter. Wir senden eine Bestätigungs-E-Mail und ändern nichts ohne Ihre Bestätigung.",
    "gdpr.email": "Für diesen Betrieb registrierte E-Mail",
    "gdpr.type": "Schreiben Sie {word}, um fortzufahren",
    "gdpr.send": "Bestätigungs-E-Mail senden",
    "gdpr.cancel": "Abbrechen",
    "gdpr.sent": "Bestätigungs-E-Mail an {mail} gesendet",
    "x.bk.download": "Daten herunterladen", "x.bk.downloaded": "Backup heruntergeladen",
    "x.bk.restore": "Aus Datei wiederherstellen", "x.bk.restoreOk": "Daten wiederhergestellt",
    "x.bk.warn": "Die Wiederherstellung überschreibt die aktuellen Daten. Vorher wird automatisch eine Sicherungskopie erstellt.",
    "x.bk.records": "Datensätze", "x.bk.history": "Durchgeführte Wiederherstellungen",
    "x.bk.pick": "Backup-Datei auswählen", "x.bk.bad": "Ungültige Backup-Datei",
    "x.bk.content": "Inhalt des Backups",
    "x.off.banner": "Sie sind offline: nur Lesezugriff, Daten vom letzten Stand.",
    "beta.tag": "BETA-Version in Entwicklung",
    "beta.long": "— einige Teile entstehen noch: wenn etwas nicht passt, sagen Sie es uns.",
    "beta.cta": "Ihre Meinung",
    "beta.notice": "Dies ist eine Beta-Version in Entwicklung: einige Teile werden sich noch ändern. Wenn Sie sie testen, freue ich mich über Ihre Rückmeldung.",
    "fb.fab": "Ihre Meinung",
    "fb.title": "Wie war der Test?",
    "fb.intro": "Reprehendo ist in der Beta-Phase: Ihre Meinung entscheidet, was wir zuerst bauen. Eine Minute, sechs Fragen.",
    "fb.q1": "Gesamtbewertung",
    "fb.q2": "Wie einfach ist die Bedienung",
    "fb.q3": "Der Teil, der Ihnen am besten gefallen hat",
    "fb.q4": "Was fehlt oder was würden Sie ändern?",
    "fb.q4ph": "Schreiben Sie frei: das ist die Antwort, die wir am meisten brauchen.",
    "fb.q5": "Würden Sie es in Ihrem Betrieb einsetzen?",
    "fb.q6": "E-Mail (optional), wenn Sie Neuigkeiten möchten",
    "fb.q6note": "Kein Newsletter: nur als Antwort auf Ihre Rückmeldung.",
    "fb.yes": "Ja", "fb.maybe": "Vielleicht", "fb.no": "Nein",
    "fb.send": "Fragebogen senden",
    "fb.needRating": "Bitte geben Sie mindestens die Gesamtbewertung ab",
    "fb.thanks": "Danke, erhalten!",
    "fb.thanksSub": "Jeder Hinweis landet direkt auf unserer Aufgabenliste.",
    "fb.close": "Schließen",
  },
};
